/**
 * Builds a /depart/ search URL matching ui-react's expected format.
 * Centralizes URL construction to avoid inconsistencies across components.
 */
export function buildDepartUrl(params: {
    origin: string
    destination: string
    date: string
    locale?: string
    query?: Record<string, string>
}): string {
    const { origin, destination, date, locale, query } = params
    const prefix = locale ? `/${locale}` : ''
    const path = `${prefix}/depart/${encodeURIComponent(origin)}/${encodeURIComponent(destination)}/${date}/`

    if (!query || Object.keys(query).length === 0) {
        return path
    }

    const qs = new URLSearchParams(query)
    return `${path}?${qs}`
}
